import { get, put, post } from 'utils/methods';

export function getUsersApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_USERS}user`, data, headers);
}

export function getUsersGroupsApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_USERS}user-group`, data, headers);
}

export function getresellersApi(data, headers) {
    return get(`${process.env.REACT_APP_REST}resellers`, data, headers);
}

export function getpermissionGroupApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_USERS}permission-group`, data, headers);
}

export function enableStatusUserApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_USERS}commands/user/enable`, data, headers);
}

export function disableStatusUserApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_USERS}commands/user/disable`, data, headers);
}

export function addNewUserApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_USERS}commands/user`, data, headers);
}

export function editUserApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_USERS}commands/user`, data, headers);
}

export function addNewUserGroupApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_USERS}commands/user-group`, data, headers);
}

export function editUserGroupApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_USERS}commands/user-group`, data, headers);
}
